import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { grandviewMOConfig } from "./data";

export default function GrandviewMOPage() {
  return <CityPageTemplate config={grandviewMOConfig} />;
}